/*
  $emit
    onDataChanged(data)
    companyIdChange
 */

<template>
  <div>
    <el-select v-model="companyArr" multiple placeholder="请添加开班单位" v-if="editId==1">
      <el-option v-for="item in datas" :key="item.id" :label="item.title" :value="item.id"></el-option>
    </el-select>
    <el-select v-model="data" placeholder="请选择开班单位" @change="onDataChanged" v-else>
      <el-option v-for="item in datas" :key="item.id" :label="item.title" :value="item.id"></el-option>
    </el-select>
  </div>
</template>

<script>
import { BaseVue } from "@/mixin/index";
import { optionsApi } from "@/api/module/classunit/classunit";

export default {
  name: "StudyclassUnitidSelect",
  
  mixins: [BaseVue],
  
  data() {
    return {
      data: "", // data
      datas: [], // ...
      companyArr: [], // 单位id数组
      editId: "0" // 修改页面的标识 1展示修改页面
    };
  },
  
  methods: {
    initData(data) {
      this.data = data;
    },
    
    editData(e) {
      this.editId = e;
      console.log(111, this.editId);
    },
    
    onDataChanged(e) {
      // 可以添加其他逻辑
    }
  },
  
  created() {
    const data = {
      test: 1
    };

    optionsApi(data)
      .then(response => {
        this.datas = response;
      })
      .catch(error => {
        console.log(error);
      })
      .finally(() => {});
  },
  
  watch: {
    data: {
      handler() {
        this.$emit("onDataChanged", this.data);
      }
    },
    companyArr: {
      handler() {
        this.$emit("companyIdChange", this.companyArr);
      }
    }
  }
};
</script>